// Shared number formatting for the Methodology Report sections. Mirrors the
// whole-number / two-decimal / signed-delta styling used in the source HTML report.

const wholeNumberFormatter = new Intl.NumberFormat(undefined, {
  maximumFractionDigits: 0
})

const toFiniteNumber = (value: number | string | null | undefined): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value === 'string') {
    const normalized = value.trim().replace(/,/g, '')
    if (normalized === '') return null
    const n = Number(normalized)
    return Number.isFinite(n) ? n : null
  }
  return null
}

export const formatWhole = (value: number | string | null | undefined): string => {
  const n = toFiniteNumber(value)
  return n === null ? '' : wholeNumberFormatter.format(n)
}

export const formatFixed = (value: number | string | null | undefined, digits = 3): string => {
  const n = toFiniteNumber(value)
  return n === null ? '' : n.toFixed(digits)
}

/** Signed value (e.g. "+0.008730" / "-0.001770") used for delta columns. */
export const formatSignedFixed = (
  value: number | string | null | undefined,
  digits = 6
): string => {
  const n = toFiniteNumber(value)
  if (n === null) return ''
  const body = Math.abs(n).toFixed(digits)
  return n < 0 ? `-${body}` : `+${body}`
}

/** Tailwind text color for a delta value: red when worse (positive), green when better. */
export const deltaColorClass = (
  value: number | string | null | undefined,
  // For most drag/lift deltas a higher value is "worse"; pass false to invert.
  higherIsWorse = true
): string => {
  const n = toFiniteNumber(value)
  if (n === null || n === 0) return ''
  const worse = higherIsWorse ? n > 0 : n < 0
  return worse ? 'text-red-600' : 'text-green-700'
}
